export default function EventMixin ( Base ) {
    return class extends Base {
        eventListeners = {};

        on ( event, listener ) {
            if ( !this.eventListeners[ event ] ) {
                this.eventListeners[ event ] = [];
            }
            this.eventListeners[ event ].push( listener );
        }

        off ( event, listener ) {
            if ( !this.eventListeners[ event ] ) return;
            this.eventListeners[ event ] = this.eventListeners[ event ].filter(
                ( l ) => l !== listener
            );
        }

        emit ( event, ...args ) {
            if ( !this.eventListeners[ event ] ) return;
            this.eventListeners[ event ].forEach( ( listener ) => listener( ...args ) );
        }
    };
}

export const Event = EventMixin( class { } );
